<template>
  <LayoutMinimal>
    <div id="sing-up">
      <section class="main">
        <div class="container">
          <div class="form loadable failable">
            <h1 class="title">
              {{ $t("claims.title") }}
            </h1>
            <ReportForm
              @successfull="successfullHandler"
              @failed="failedHandler"
              @cancel="cancelHandler"
            />

            <div class="loader-wrapper">
              <Spinner />
            </div>
          </div>
        </div>
      </section>
    </div>
    <template slot="after">
      <Footer />
    </template>
  </LayoutMinimal>
</template>

<script>
import Spinner from "../../components/Spinner";
import Footer from "../../components/Footer";
import LayoutMinimal from "../../layouts/LayoutMinimal";
import ReportForm from "../../components/Form/ModelReport.vue";

export default {
  components: {
    ReportForm,
    LayoutMinimal,
    Spinner,
    Footer,
  },
  methods: {
    successfullHandler() {
      this.goBackOrHome()
    },
    failedHandler() {},
    cancelHandler() {
      this.goBackOrHome()
    },
    goBackOrHome() {
      if (this.$route.meta.previousRoute) {
        // Si hay una ruta anterior almacenada, redirigimos a ella
        //this.$router.push(this.$route.meta.previousRoute);
        this.$router.back();
      } else {
        // Si no hay una ruta anterior almacenada, redirigimos al home
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

#sing-up {
  background-color: var(--pallete_dark_color);
  display: flex;
  color: var(--pallete_clear_text_color);
  flex-direction: column;
  justify-content: center;
  max-width: 750px;

  .highlight-payment-box {
    margin: 1em;
  }

  .btn.login {
    @extend %fresh-btn;
    display: block;
    width: 100%;
    padding: 1em;
  }

  section.main {
    justify-content: space-around;
    position: relative;
    margin: 0;

    .container {
      display: flex;
      margin: 0 auto;
      padding: 1.5em;
      background-color: var(--background_01);
      border-radius: 10px;
      margin-left: 1em;
      margin-right: 1em;

      @media (max-width: 450px) {
        border-radius: 0;
        margin-left: 0;
        margin-right: 0;
        padding: 0.5em;
        width: 100vw;
      }

      .form {
        display: block;
        padding: 1em;
        border-radius: 5px;
        width: 100%;

        .title {
          text-align: center;
          width: 100%;
          text-transform: uppercase;
          letter-spacing: 0;
          margin: 0 0 0.5em 0;
        }

        @media (max-width: 500px) {
          min-width: auto;
        }
      }
    }
  }

  .failed-wrapper > p {
    text-align: center;
    font-weight: bolder;
    padding-top: 1em;
    color: red;
  }
}
</style>
